import Modal from 'react-native-modal/dist/modal';
import React, { PropsWithChildren } from 'react';
import { BgOverlayLight, COLORS } from '../../config/designSystem/Colors';
import { DropShadowMedium } from '../DropShadows/DropShadowMedium';
import { SPACING } from '../../config/designSystem/Spacing';
import { TouchableWithoutFeedback, View, useWindowDimensions } from 'react-native';
import { isWeb } from '../../config/designSystem/Layout';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';
import { useSystemBottomInset } from '../../hooks/ui/useSystemBottomInset';

interface ModalBelowProps extends PropsWithChildren{
    isVisible: boolean;
    onDismiss: () => void;
  }

export const BasicModalBelowWrapper = ({ isVisible, onDismiss, children}: ModalBelowProps) => {
  const {height, width} = useAvailableDimensions();
  const {width: widthComplete} = useWindowDimensions();
  const BORDER_RADIUS= SPACING['sp-32'];
  // This sheet is pinned to the bottom of a full-screen modal, so under Android
  // edge-to-edge its action button ran under the system navigation bar -- reproduced
  // on an API 36 device with the dashboard "Got it" drawer.
  const systemBottomInset = useSystemBottomInset();

  const shouldBeCentered = isWeb;

  return (
    <DropShadowMedium>
      <View style={[shouldBeCentered && { flex: 1, height, width: widthComplete, backgroundColor: BgOverlayLight, opacity: 0.7 }]}>
        <Modal
          isVisible={isVisible}
          style={[{
            overflow: 'hidden',
            margin: 0,
            alignSelf: 'center',
          }, shouldBeCentered && {
            width:  0.9*width,
          }, !shouldBeCentered && {
            position: 'absolute',
            bottom: 0,
            width
          }]}
          onBackButtonPress={() => { onDismiss(); }}
          onBackdropPress={()=> {onDismiss();}}
          propagateSwipe
          // customBackdrop needed for backgroundColor and resize with window on web
          customBackdrop={
            <TouchableWithoutFeedback onPress={onDismiss}>
              <View style={{ flex: 1, height, width: widthComplete, backgroundColor: BgOverlayLight, opacity: 0.7 }} />
            </TouchableWithoutFeedback>
          }
        >
          <View style={[{
            justifyContent:'center',
            alignItems: 'center',
            backgroundColor: COLORS.surface.contrast,
            paddingVertical: SPACING['sp-32'],
            paddingBottom: SPACING['sp-32'] + systemBottomInset,
            paddingHorizontal: SPACING['sp-16'],
            borderTopLeftRadius: BORDER_RADIUS,
            borderTopRightRadius: BORDER_RADIUS,
          }, shouldBeCentered && {
            borderBottomLeftRadius: BORDER_RADIUS,
            borderBottomRightRadius: BORDER_RADIUS,
          }]}>
            {children}
          </View>
        </Modal>
      </View>
    </DropShadowMedium>

  );
};


